import { render, staticRenderFns } from "./ProfileActionsDropdown.vue?vue&type=template&id=36f6b7dc&"
import script from "./ProfileActionsDropdown.vue?vue&type=script&lang=js&"
export * from "./ProfileActionsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ProfileActionsDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports